import Vue from 'vue';
import Component from 'vue-class-component';

import { mapGetters, mapActions } from 'vuex';
import UserCard from '@/components/common/UserCard';
import RulesAndInfo from '@/components/common/RulesAndInfo';

@Component({
  name: 'site-sidebar',
  components: {
    UserCard,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vcoConfig: {
        handler: () => {
          this.$emit('close');
        },
        middleware: event => {
          return !event.target.classList.contains('btn-sidebar-opener');
        },
      },
    };
  },
  computed: mapGetters(['user', 'isLoggedIn', 'activeGameId', 'activeDuelId']),
  watch: {
    $route() {
      this.$emit('close');
    },
  },
  methods: mapActions(['userLogout']),
})
export default class SiteSidebar extends Vue {
  // !METHODS
  onLogOut() {
    this.$q
      .dialog({
        title: this.$t('titles.log_out'),
        message: this.$t('messages.log_out_confirm'),
        ok: {
          label: this.$t('Yes'),
          color: 'negative',
        },
        cancel: {
          label: this.$t('No'),
          textColor: 'black',
          color: 'white',
        },
        persistent: true,
      })
      .onOk(this.userLogout);
  }
  showRules() {
    this.$q.dialog({
      root: this.$root,
      component: RulesAndInfo,
      maximized: true,
    });
  }
}
